/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Icon} from "@material-ui/core"
import {Link, Switch, Redirect} from "react-router-dom";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {ContentRoute} from "../../../../_metronic/layout"
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import ForgotID from "./ForgotID";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

export function AuthPage() {
  return (
    <div className="d-flex flex-column flex-root">
      {/*begin::Login*/}
      <div
        id="kt_login"
        className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
      >
        {/*begin::Aside*/}
        <div
          className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
          style={{ backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-4.jpg")})` }}
        >
          {/*begin: Aside Container*/}
          <div className="d-flex flex-row-fluid flex-column justify-content-between">

            {/* start:: Aside header */}
            <Link to="/" className="flex-column-auto mt-5">
              <img
                alt="Logo"
                className="max-h-70px"
                src={toAbsoluteUrl("/media/logos/logo-letter-1.png")}
              />
            </Link>
            {/* end:: Aside header */}

            {/* start:: Aside content */}
            <div className="flex-column-fluid d-flex flex-column justify-content-center">
              <h3 className="font-size-h1 mb-5 text-white">
                Welcome to Lullu!
              </h3>
              <p className="font-weight-lighter text-white opacity-80">
                {/* The ultimate Bootstrap & React 16 admin theme framework for next
                generation web apps. */}
              </p>
            </div>
            {/* end:: Aside content */}

            {/* start:: Aside footer for desktop */}
            <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
              <div className="opacity-70 font-weight-bold	text-white">
                Powered by Pentaworks
              </div>
            </div>
            {/* end:: Aside footer for desktop */}
          </div>
          {/*end: Aside Container*/}
        </div>
        {/*begin::Aside*/}

        {/*begin::Content*/}
        <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">

          {/*begin::Content header*/}
          <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
            <a
              href="https://partner.lullu.biz/login"
              className="font-weight-bold ml-2"
            >
              공급파트너로 로그인
            </a>
            <span className="font-weight-bold text-dark-50">
              하기
              <Icon className="align-middle ml-1">
                arrow_right_alt_rounded
              </Icon>
            </span>
          </div>
          {/*end::Content header*/}

          {/* begin::Content body */}
          <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
            <Switch>
              <ContentRoute path="/login" component={Login}/>
              <ContentRoute path="/registration" component={Registration}/>
              <ContentRoute path="/forgot-password" component={ForgotPassword}/>
              <ContentRoute path="/forgot-id" component={ForgotID}/>
              <Redirect from="/auth" exact={true} to="/login"/>
              <Redirect to="/login"/>
            </Switch>
          </div>
          {/*end::Content body*/}

          {/* begin::Mobile footer */}
          <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
              Powered by Pentaworks
            </div>
          </div>
          {/* end::Mobile footer */}
        </div>
        {/*end::Content*/}
      </div>
      {/*end::Login*/}
    </div>
  );
}
